// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  padding: 30px 0px 20px;
  overflow-x: hidden;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: var(--background-default);
}
.wrapper.dark-wrapper {
  background-color: #0d0d0d;
}
.wrapper .close-icon {
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
  width: 22px;
  height: 22px;
  z-index: 100;
}
.wrapper .header-wrapper {
  text-align: center;
  width: 100%;
  margin-bottom: 25px;
  margin-top: 25px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 20px;
}
.wrapper .header-wrapper.dark-header {
  margin-bottom: 40px;
}
.wrapper .header-wrapper::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 20px;
  width: 100%;
  height: 3px;
  background-color: transparent;
}
.wrapper .header-wrapper.dark-header::after {
  width: 60%;
  max-width: 300px;
}
.wrapper .title {
  width: 100%;
  font-size: 34px;
  font-weight: 700;
  color: var(--color-black);
  padding: 0;
  text-align: left;
  margin: 0;
  letter-spacing: 0.5px;
  line-height: 1.2;
  font-family: var(--ion-font-family);
}
.wrapper .title.dark-title {
  color: #ffffff;
  font-family: AppFontEintrachtOFC;
  font-size: 30px;
}
.wrapper.dark-wrapper .header-wrapper::after {
  background-color: #e30613;
}

.content_block {
  height: calc(100% - 80px);
  overflow: visible;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 90px;
}

.recommendation-swiper {
  width: 100%;
  height: auto;
  padding-bottom: 20px;
}
.recommendation-swiper swiper-slide {
  width: 220px !important;
  height: auto;
  display: flex;
}

.article-card {
  width: 220px;
  height: 295.5px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  position: relative;
  background: var(--ion-color-white);
}
.article-card.selected {
  opacity: 0.95;
}
.article-card .article-img-wrapper {
  width: 100%;
  height: 140px;
  display: flex;
  overflow: hidden;
}
.article-card .article-img-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  clip-path: polygon(18px 0, 100% 0, 100% 100%, 0 100%, 0 18px);
}
.article-card .article-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0;
}
.article-card .article-title {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 10px 12px 6px;
}
.article-card .article-title .article-name {
  display: block;
  width: 100%;
  margin: 0 0 6px 0;
  font-size: 14px;
  line-height: 1.2;
  font-weight: 700;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 34px;
}
.article-card .article-title .article-price {
  width: 100%;
}
.article-card .article-title .article-price .price {
  margin: 0;
  width: max-content;
  font-size: 14px;
  font-weight: 700;
  font-family: var(--ion-font-family);
}
.article-card .article-info {
  margin: 0 12px 10px;
  color: var(--ion-color-text-gery);
  font-size: 11px;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 42px;
}
.article-card .article-footer {
  width: calc(100% - 24px);
  margin: 0 12px 12px;
  display: flex;
  margin-top: auto;
  position: relative;
  min-height: 44px;
}
.article-card .article-footer ion-button {
  transition: all 0.2s ease-in-out;
  width: 100%;
  padding: 0;
  --border-width: 0px;
  --border-style: none;
  font-family: var(--ion-font-family);
  height: 40px;
  margin: 0;
  font-size: 16px;
  font-weight: 700;
}
.article-card .article-footer .quantity-regulator {
  width: 0;
  transition: all 0.2s ease-in-out;
  display: none;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  padding: 0;
}
.article-card .article-footer .quantity-regulator img {
  height: 18px;
  width: 18px;
  cursor: pointer;
  flex-shrink: 0;
}
.article-card .article-footer .quantity-regulator .quantity {
  min-width: 20px;
  text-align: center;
}
.article-card .article-footer.active .quantity-regulator {
  padding: 0 10px;
  width: 50%;
  display: flex;
  height: 44px;
  justify-content: space-around;
}
.article-card .article-footer.active ion-button {
  width: 55%;
  min-height: 44px;
  position: absolute;
  right: 0;
}
.article-card .article-footer.active-eintracht .quantity-regulator {
  padding: 0 10px;
  width: 50%;
  display: flex;
  height: 40px;
  justify-content: space-around;
}
.article-card .article-footer.active-eintracht ion-button {
  background: #e30613;
  border: none;
  border-radius: 6px;
  width: 55%;
  color: #fff;
  min-height: 40px;
  position: absolute;
  right: 0;
}

.cut-card {
  border: none;
  background-color: transparent;
  position: relative;
  --card-skew: 18px;
  clip-path: polygon(var(--card-skew) 0, 100% 0, 100% calc(100% - var(--card-skew)), calc(100% - var(--card-skew)) 100%, 0 100%, 0 var(--card-skew));
  box-sizing: border-box;
}
.cut-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background-color: #d2d2d2;
  clip-path: polygon(0 var(--card-skew), var(--card-skew) 0, 100% 0, 100% calc(100% - var(--card-skew)), calc(100% - var(--card-skew)) 100%, 0 100%, 0 var(--card-skew), 2px calc(var(--card-skew) + 0.83px), 2px calc(100% - 2px), calc(100% - var(--card-skew) - 0.83px) calc(100% - 2px), calc(100% - 2px) calc(100% - var(--card-skew) - 0.83px), calc(100% - 2px) 2px, calc(var(--card-skew) + 0.83px) 2px, 2px calc(var(--card-skew) + 0.83px));
  pointer-events: none;
}

.dark-theme-card {
  background-color: #1a1a1a;
  border: 1px solid #383838;
  border-radius: 6px;
}
.dark-theme-card .article-img-wrapper img {
  clip-path: none;
  border-bottom: none;
  border-radius: 6px 6px 0 0;
  background-color: #121212;
}
.dark-theme-card .article-title .article-name {
  color: #ffffff;
  font-family: EintrachtDisplay;
}
.dark-theme-card .article-title .article-price .price {
  color: #ffffff;
  font-family: EintrachtDisplay;
}
.dark-theme-card .article-info {
  color: #b3b3b3;
  font-family: AppFontEintrachtOFCSans;
}
.dark-theme-card .article-footer ion-button {
  color: #ffffff;
  background: transparent;
  border: 1px solid #E30613;
  min-height: 40px;
}

.quantity {
  font-size: 18px;
  font-family: var(--ion-font-family);
  font-weight: 700;
  padding-top: 2px;
}

.footer-btn {
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  width: calc(100% - 40px);
  display: flex;
  justify-content: center;
  z-index: 100;
}
.footer-btn ion-button {
  margin: 0;
  width: 100%;
  height: 50px;
  --border-width: 0;
  --border-style: none;
  --box-shadow: none;
  font-family: var(--ion-font-family);
}
.footer-btn ion-button.btn {
  --background: transparent;
  color: #ffffff;
}
.footer-btn ion-button.btn-eintracht {
  --background: #e30613;
  color: #ffffff;
}

.article-card.dark-theme-card .article-title {
  flex-direction: row;
  width: auto;
}
.article-card.dark-theme-card .article-title .article-price {
  display: flex;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/app/components/recomendation-article-modal/recomendation-article-modal.component.scss"],"names":[],"mappings":"AAEA;EACC,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2CAAA;AADD;AAGC;EACC,yBAAA;AADF;AAIC;EACC,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAFF;AAKC;EACC,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AAHF;AAIE;EACC,mBAAA;AAFH;AAKE;EACC,WAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,6BAAA;AAHH;AAME;EACC,UAAA;EACA,gBAAA;AAJH;AAQC;EACC,WAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,UAAA;EACA,gBAAA;EACA,SAAA;EACA,qBAAA;EACA,gBAAA;EACA,mCAAA;AANF;AAQE;EACC,cAAA;EACA,gCAAA;EACA,eAAA;AANH;AAUC;EACC,yBAAA;AARF;;AAWA;EACC,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AARD;;AAWA;EACC,WAAA;EACA,YAAA;EACA,oBAAA;AARD;AAUC;EACC,uBAAA;EACA,YAAA;EACA,aAAA;AARF;;AAYA;EACC,YAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,kCAAA;AATD;AAWC;EACC,aAAA;AATF;AAYC;EACC,WAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;AAVF;AAYE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,6DAAA;AAVH;AAeC;EACC,aAAA;EACA,sBAAA;EACA,OAAA;EACA,UAAA;AAbF;AAgBC;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;AAdF;AAgBE;EACC,cAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AAdH;AAiBE;EACC,WAAA;AAfH;AAiBG;EACC,SAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;AAfJ;AAoBC;EACC,mBAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;AAlBF;AAqBC;EACC,wBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EAEA,kBAAA;EACG,gBAAA;AApBL;AAsBE;EACC,gCAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,oBAAA;EACA,mCAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AApBH;AAuBE;EACC,QAAA;EACA,gCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;AArBH;AAuBG;EACC,YAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AArBJ;AAwBG;EACC,eAAA;EACA,kBAAA;AAtBJ;AA4BE;EACC,eAAA;EAEA,UAAA;EACA,aAAA;EAEA,YAAA;EACA,6BAAA;AA5BH;AA+BE;EAEC,UAAA;EAEA,gBAAA;EAEA,kBAAA;EACA,QAAA;AAhCH;AAqCE;EACC,eAAA;EAEA,UAAA;EACA,aAAA;EACA,YAAA;EACA,6BAAA;AApCH;AAuCE;EACC,mBAAA;EACA,YAAA;EACA,kBAAA;EAEA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;AAtCH;;AA4CA;EACC,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,kJAAA;EAQA,sBAAA;AAhDD;AAkDC;EACC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,yBAAA;EACA,mbAAA;EAgBA,oBAAA;AA/DF;;AAoEA;EACC,yBAAA;EACA,yBAAA;EACA,kBAAA;AAjED;AAoEE;EACC,eAAA;EACA,mBAAA;EACA,0BAAA;EACA,yBAAA;AAlEH;AAuEE;EACC,cAAA;EACA,6BAAA;AArEH;AAyEG;EACC,cAAA;EACA,6BAAA;AAvEJ;AA4EC;EACC,cAAA;EACA,oCAAA;AA1EF;AA8EE;EACC,cAAA;EACA,uBAAA;EACG,yBAAA;EACH,gBAAA;AA5EH;;AAiFA;EAEC,eAAA;EACA,mCAAA;EACA,gBAAA;EACA,gBAAA;AA/ED;;AAkFA;EACC,eAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;AA/ED;AAiFC;EACC,SAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mCAAA;AA/EF;AAiFE;EACC,yBAAA;EACA,cAAA;AA/EH;AAkFE;EACC,qBAAA;EACA,cAAA;AAhFH;;AAuFE;EACC,mBAAA;EACA,WAAA;AApFH;AAqFG;EACC,aAAA;EACA,yBAAA;AAnFJ","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper {\n\tpadding: 30px 0px 20px;\n\toverflow-x: hidden;\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tbackground-color: var(--background-default);\n\n\t&.dark-wrapper {\n\t\tbackground-color: #0d0d0d;\n\t}\n\n\t.close-icon {\n\t\tcursor: pointer;\n\t\tposition: absolute;\n\t\ttop: 20px;\n\t\tright: 20px;\n\t\twidth: 22px;\n\t\theight: 22px;\n\t\tz-index: 100;\n\t}\n\n\t.header-wrapper {\n\t\ttext-align: center;\n\t\twidth: 100%;\n\t\tmargin-bottom: 25px;\n\t\tmargin-top: 25px;\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t\tpadding-left: 20px;\n\t\t&.dark-header {\n\t\t\tmargin-bottom: 40px;\n\t\t}\n\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\tbottom: -10px;\n\t\t\tleft: 20px;\n\t\t\twidth: 100%;\n\t\t\theight: 3px;\n\t\t\tbackground-color: transparent;\n\t\t}\n\n\t\t&.dark-header::after {\n\t\t\twidth: 60%;\n\t\t\tmax-width: 300px;\n\t\t}\n\t}\n\n\t.title {\n\t\twidth: 100%;\n\t\tfont-size: 34px;\n\t\tfont-weight: 700;\n\t\tcolor: var(--color-black);\n\t\tpadding: 0;\n\t\ttext-align: left;\n\t\tmargin: 0;\n\t\tletter-spacing: 0.5px;\n\t\tline-height: 1.2;\n\t\tfont-family: var(--ion-font-family);\n\n\t\t&.dark-title {\n\t\t\tcolor: #ffffff;\n\t\t\tfont-family: AppFontEintrachtOFC;\n\t\t\tfont-size: 30px;\n\t\t}\n\t}\n\n\t&.dark-wrapper .header-wrapper::after {\n\t\tbackground-color: #e30613;\n\t}\n}\n.content_block {\n\theight: calc(100% - 80px);\n\toverflow: visible;\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding-bottom: 90px;\n}\n\n.recommendation-swiper {\n\twidth: 100%;\n\theight: auto;\n\tpadding-bottom: 20px;\n\n\tswiper-slide {\n\t\twidth: 220px !important;\n\t\theight: auto;\n\t\tdisplay: flex;\n\t}\n}\n\n.article-card {\n\twidth: 220px;\n\theight: 295.5px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tcursor: pointer;\n\tposition: relative;\n\tbackground: var(--ion-color-white);\n\n\t&.selected {\n\t\topacity: 0.95;\n\t}\n\n\t.article-img-wrapper {\n\t\twidth: 100%;\n\t\theight: 140px;\n\t\tdisplay: flex;\n\t\toverflow: hidden;\n\n\t\timg {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: cover;\n\t\t\tobject-position: center;\n\t\t\tclip-path: polygon(18px 0, 100% 0, 100% 100%, 0 100%, 0 18px);\n\t\t\t// border-bottom: 1px solid var(--ion-color-grey);\n\t\t}\n\t}\n\n\t.article-content {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tflex: 1;\n\t\tpadding: 0;\n\t}\n\n\t.article-title {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 100%;\n\t\tmargin: 10px 12px 6px;\n\n\t\t.article-name {\n\t\t\tdisplay: block;\n\t\t\twidth: 100%;\n\t\t\tmargin: 0 0 6px 0;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 1.2;\n\t\t\tfont-weight: 700;\n\t\t\tdisplay: -webkit-box;\n\t\t\t-webkit-line-clamp: 2;\n\t\t\tline-clamp: 2;\n\t\t\t-webkit-box-orient: vertical;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t\theight: 34px;\n\t\t}\n\n\t\t.article-price {\n\t\t\twidth: 100%;\n\n\t\t\t.price {\n\t\t\t\tmargin: 0;\n\t\t\t\twidth: max-content;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 700;\n\t\t\t\tfont-family: var(--ion-font-family);\n\t\t\t}\n\t\t}\n\t}\n\n\t.article-info {\n\t\tmargin: 0 12px 10px;\n\t\tcolor: var(--ion-color-text-gery);\n\t\tfont-size: 11px;\n\t\tline-height: 1.3;\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: 3;\n\t\tline-clamp: 3;\n\t\t-webkit-box-orient: vertical;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\theight: 42px;\n\t}\n\n\t.article-footer {\n\t\twidth: calc(100% - 24px);\n\t\tmargin: 0 12px 12px;\n\t\tdisplay: flex;\n\t\tmargin-top: auto;\n\t\t// gap: 8px;\n\t\tposition: relative;\n    \tmin-height: 44px;\n\n\t\tion-button {\n\t\t\ttransition: all 0.2s ease-in-out;\n\t\t\twidth: 100%;\n\t\t\tpadding: 0;\n\t\t\t--border-width: 0px;\n\t\t\t--border-style: none;\n\t\t\tfont-family: var(--ion-font-family);\n\t\t\theight: 40px;\n\t\t\tmargin: 0;\n\t\t\tfont-size: 16px;\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\t.quantity-regulator {\n\t\t\twidth: 0;\n\t\t\ttransition: all 0.2s ease-in-out;\n\t\t\tdisplay: none;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t\tfont-size: 15px;\n\t\t\tpadding: 0;\n\n\t\t\timg {\n\t\t\t\theight: 18px;\n\t\t\t\twidth: 18px;\n\t\t\t\tcursor: pointer;\n\t\t\t\tflex-shrink: 0;\n\t\t\t}\n\n\t\t\t.quantity {\n\t\t\t\tmin-width: 20px;\n\t\t\t\ttext-align: center;\n\t\t\t}\n\t\t}\n\t}\n\n\t.article-footer.active {\n\t\t.quantity-regulator {\n\t\t\tpadding: 0 10px;\n\t\t\t// width: 90px;\n\t\t\twidth: 50%;\n\t\t\tdisplay: flex;\n\t\t\t// height: 40px;\n\t\t\theight: 44px;\n\t\t\tjustify-content: space-around;\n\t\t}\n\n\t\tion-button {\n\t\t\t// --background: var(--ion-color-black);\n\t\t\twidth: 55%;\n\t\t\t// width: calc(100% - 98px);\n\t\t\tmin-height: 44px;\n\t\t\t// color: var(--ion-color-white);\n\t\t\tposition: absolute;\n\t\t\tright: 0;\n\t\t}\n\t}\n\n\t.article-footer.active-eintracht {\n\t\t.quantity-regulator {\n\t\t\tpadding: 0 10px;\n\t\t\t// width: 90px;\n\t\t\twidth: 50%;\n\t\t\tdisplay: flex;\n\t\t\theight: 40px;\n\t\t\tjustify-content: space-around;\n\t\t}\n\n\t\tion-button {\n\t\t\tbackground: #e30613;\n\t\t\tborder: none;\n\t\t\tborder-radius: 6px;\n\t\t\t// width: calc(100% - 98px);\n\t\t\twidth: 55%;\n\t\t\tcolor: #fff;\n\t\t\tmin-height: 40px;\n\t\t\tposition: absolute;\n\t\t\tright: 0;\n\t\t}\n\t}\n}\n\n// Cut card design (when name is not present)\n.cut-card {\n\tborder: none;\n\tbackground-color: transparent;\n\tposition: relative;\n\t--card-skew: 18px;\n\tclip-path: polygon(\n\t\tvar(--card-skew) 0,\n\t\t100% 0,\n\t\t100% calc(100% - var(--card-skew)),\n\t\tcalc(100% - var(--card-skew)) 100%,\n\t\t0 100%,\n\t\t0 var(--card-skew)\n\t);\n\tbox-sizing: border-box;\n\n\t&::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tinset: 0;\n\t\tbackground-color: #d2d2d2;\n\t\tclip-path: polygon(\n\t\t\t0 var(--card-skew),\n\t\t\tvar(--card-skew) 0,\n\t\t\t100% 0,\n\t\t\t100% calc(100% - var(--card-skew)),\n\t\t\tcalc(100% - var(--card-skew)) 100%,\n\t\t\t0 100%,\n\t\t\t0 var(--card-skew),\n\t\t\t2px calc(var(--card-skew) + 0.83px),\n\t\t\t2px calc(100% - 2px),\n\t\t\tcalc(100% - var(--card-skew) - 0.83px) calc(100% - 2px),\n\t\t\tcalc(100% - 2px) calc(100% - var(--card-skew) - 0.83px),\n\t\t\tcalc(100% - 2px) 2px,\n\t\t\tcalc(var(--card-skew) + 0.83px) 2px,\n\t\t\t2px calc(var(--card-skew) + 0.83px)\n\t\t);\n\t\tpointer-events: none;\n\t}\n}\n\n// Dark theme card (when name is present)\n.dark-theme-card {\n\tbackground-color: #1a1a1a;\n\tborder: 1px solid #383838;\n\tborder-radius: 6px;\n\n\t.article-img-wrapper {\n\t\timg {\n\t\t\tclip-path: none;\n\t\t\tborder-bottom: none;\n\t\t\tborder-radius: 6px 6px 0 0;\n\t\t\tbackground-color: #121212;\n\t\t}\n\t}\n\n\t.article-title {\n\t\t.article-name {\n\t\t\tcolor: #ffffff;\n\t\t\tfont-family: EintrachtDisplay;\n\t\t}\n\n\t\t.article-price {\n\t\t\t.price {\n\t\t\t\tcolor: #ffffff;\n\t\t\t\tfont-family: EintrachtDisplay;\n\t\t\t}\n\t\t}\n\t}\n\n\t.article-info {\n\t\tcolor: #b3b3b3;\n\t\tfont-family: AppFontEintrachtOFCSans;\n\t}\n\n\t.article-footer {\n\t\tion-button {\n\t\t\tcolor: #ffffff;\n\t\t\tbackground: transparent;\n    \t\tborder: 1px solid #E30613;\n\t\t\tmin-height: 40px;\n\t\t}\n\t}\n}\n\n.quantity {\n\t// font-size: 16px;\n\tfont-size: 18px;\n\tfont-family: var(--ion-font-family);\n\tfont-weight: 700;\n\tpadding-top: 2px;\n}\n\n.footer-btn {\n\tposition: fixed;\n\tbottom: 20px;\n\tleft: 20px;\n\tright: 20px;\n\twidth: calc(100% - 40px);\n\tdisplay: flex;\n\tjustify-content: center;\n\tz-index: 100;\n\n\tion-button {\n\t\tmargin: 0;\n\t\twidth: 100%;\n\t\theight: 50px;\n\t\t--border-width: 0;\n\t\t--border-style: none;\n\t\t--box-shadow: none;\n\t\tfont-family: var(--ion-font-family);\n\t\t\n\t\t&.btn {\n\t\t\t--background: transparent;\n\t\t\tcolor: #ffffff;\n\t\t}\n\t\t\n\t\t&.btn-eintracht {\n\t\t\t--background: #e30613;\n\t\t\tcolor: #ffffff;\n\t\t}\n\t}\n}\n\n.article-card {\n\t&.dark-theme-card {\n\t\t.article-title {\n\t\t\tflex-direction: row;\n\t\t\twidth: auto;\n\t\t\t.article-price {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: flex-end;\n\t\t\t}\n\t\t}\n\t}\n} \n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
